/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AccordionBody, AccordionHeader, AccordionItem, Col, ListGroup, ListGroupItem, Row, UncontrolledAccordion } from "reactstrap";
import { useTenantNavigate } from "../../../utils/tenantUrl";
import FullPageLayout from "../Layout/FullPageLayout";
import { AdminPageRouter, adminMenu } from "./Router";

export const AdminAccordionBody = ({ children, accordionId }) => (
    <AccordionBody
        accordionId={accordionId}
        css={css`& .accordion-body {
            padding: 0 !important;
        }`}
    >
        {children}
    </AccordionBody>
);

export default function AdminPage() {
    const navigate = useTenantNavigate();
    const [selectedPath, setSelectedPath] = useState(useParams()["*"]);
    const [open, setOpen] = useState(selectedPath?.split("/")[0] || "");
    const user = useSelector((state: any) => state.auth.user);
    const tenantName = user?.tenants?.length > 1 && user.tenant?.tenant_name;

    const toggle = (id) => {
        if (open === id) {
            setOpen("");
        } else {
            setOpen(id);
        }
    };

    const onMenuItemClick = (path) => {
        setSelectedPath(path);
        navigate(`/admin/${path}`);
    };

    return (
        <FullPageLayout className="bg-gray overflow-y-auto">
            <Row className="mt-3 mt-lg-5">
                <Col className="col-md-3 col-xl-2">
                    {tenantName && <h4 className="pb-3 fw-bold">{tenantName}</h4>}
                    <UncontrolledAccordion toggle={toggle} defaultOpen={[open]} stayOpen>
                        {adminMenu.map((item, index) => (
                            <AccordionItem key={index}>
                                <AccordionHeader targetId={item.path}><span className="fs-6 fw-bold">{item.title}</span></AccordionHeader>

                                <AdminAccordionBody accordionId={item.path}>
                                    <ListGroup className="rounded-0">
                                        {item.children?.map((subItem, subIndex) => {
                                            const path = `${item.path}/${subItem.path}`;

                                            return (
                                                <ListGroupItem
                                                    key={subIndex}
                                                    active={selectedPath === path}
                                                    action
                                                    tag="button"
                                                    onClick={() => onMenuItemClick(path)}
                                                    className={`border-0 ${index === adminMenu.length - 1 && subIndex === (item?.children?.length ?? 0) - 1 ? "rounded-bottom" : ""}`}
                                                >
                                                    {subItem.title}
                                                </ListGroupItem>
                                            );
                                        })}
                                    </ListGroup>
                                </AdminAccordionBody>
                            </AccordionItem>
                        ))}
                    </UncontrolledAccordion>
                </Col>

                <Col className="col-md-9 col-xl-10">
                    <AdminPageRouter />
                </Col>
            </Row>
        </FullPageLayout>
    );
}
